import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Media from './Media';
import { clearfix, toVw, toVwMobile, toVwTablet } from '../utils/styles';
import mq from '@/utils/media-queries';

const Styled = styled.div``;

const Row = styled.div`
  ${clearfix};
  margin: 0 -${toVw(36)};

  ${mq.tablet(css`
    margin: 0 -${toVwTablet(26)};
  `)};

  ${mq.mobile(css`
    margin: 0;
  `)};
`;

const Col = styled.div`
  padding: 0 ${toVw(36)};
  float: left;
  width: 50%;
  box-sizing: border-box;

  ${props => `width: ${props.width};`};

  ${mq.tablet(css`
    padding: 0 ${toVwTablet(26)};
  `)};

  ${mq.mobile(css`
    width: 100%;
    padding: 0;
    margin-bottom: ${toVwMobile(48)};

    &:last-child {
      margin-bottom: 0;
    }
  `)};
`;

const Thumb = styled(Media)``;

class Thumbs extends React.Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
  };

  render() {
    const { items } = this.props;
    return (
      <Styled>
        <Row>
          {items.map((item, index) => (
            <Col key={index} width={item.width}>
              <Thumb {...item.media} showBackground />
            </Col>
          ))}
        </Row>
      </Styled>
    );
  }
}

export default Thumbs;



// WEBPACK FOOTER //
// ./src/components/Thumbs.js